enum QuestionnaireLocale {
  QUESTIONNAIRE = "QUESTIONNAIRE"
}

export { QuestionnaireLocale}
